import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AuthContextProvider } from "./authContext/AuthContext";
import axios from "axios";

axios.defaults.baseURL =
  window.location.hostname === "pos-sks.500merchants.com"
    ? "/api/"
    : process.env.REACT_APP_API_BASE_URL;

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);